(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pratiqoo-duyuru"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const azHareket = window.matchMedia('(prefers-reduced-motion: reduce)');

    function baslat(kok) {
      kok.querySelectorAll('[data-kz-duyuru]:not([data-kz-hazir])').forEach((bant) => {
        bant.setAttribute('data-kz-hazir', '');
        const mesajlar = [...bant.querySelectorAll('[data-kz-duyuru-mesaj]')];
        if (mesajlar.length < 2) return;
        let aktif = 0;
        let zamanlayici = null;
        const sure = Number(bant.dataset.kzSure || 5) * 1000;

        const goster = (i, yon = 1) => {
          const eski = mesajlar[aktif];
          aktif = (i + mesajlar.length) % mesajlar.length;
          const yeni = mesajlar[aktif];
          if (eski === yeni) return;
          if (azHareket.matches) {
            eski.hidden = true;
            yeni.hidden = false;
            return;
          }
          bant.style.setProperty('--kz-duyuru-yon', yon);
          eski.classList.add('kz-duyuru__mesaj--cikis');
          eski.addEventListener(
            'animationend',
            () => {
              eski.hidden = true;
              eski.classList.remove('kz-duyuru__mesaj--cikis');
            },
            { once: true }
          );
          yeni.hidden = false;
          yeni.classList.add('kz-duyuru__mesaj--giris');
          yeni.addEventListener('animationend', () => yeni.classList.remove('kz-duyuru__mesaj--giris'), { once: true });
        };

        const durdur = () => {
          clearInterval(zamanlayici);
          zamanlayici = null;
        };
        const oynat = () => {
          if (azHareket.matches || zamanlayici) return;
          zamanlayici = setInterval(() => goster(aktif + 1, 1), sure);
        };

        bant.querySelector('[data-kz-duyuru-onceki]')?.addEventListener('click', () => goster(aktif - 1, -1));
        bant.querySelector('[data-kz-duyuru-sonraki]')?.addEventListener('click', () => goster(aktif + 1, 1));
        bant.addEventListener('mouseenter', durdur);
        bant.addEventListener('mouseleave', oynat);
        bant.addEventListener('focusin', durdur);
        bant.addEventListener('focusout', oynat);
        oynat();
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => baslat(document));
    else baslat(document);
    document.addEventListener('shopify:section:load', (e) => baslat(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pratiqoo-iletisim"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (e) => {
    const buton = e.target.closest('[data-kz-kopyala]');
    if (!buton) return;
    const metin = buton.dataset.kzKopyala;
    try {
      await navigator.clipboard.writeText(metin);
    } catch (err) {
      const alan = document.createElement('textarea');
      alan.value = metin;
      document.body.append(alan);
      alan.select();
      document.execCommand('copy');
      alan.remove();
    }
    const eski = buton.textContent;
    buton.textContent = buton.dataset.kzKopyalandi;
    const durum = buton.parentElement.querySelector('[data-kz-kopya-durum]');
    if (durum) durum.textContent = buton.dataset.kzKopyalandi;
    setTimeout(() => (buton.textContent = eski), 2000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pratiqoo-urun-yorumlar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const buton = e.target.closest('[data-kz-daha-yorum]');
    if (!buton) return;
    const kap = buton.closest('.kz-yorumlar__liste-kap');
    const gizli = [...kap.querySelectorAll('[data-kz-yorum-gizli][hidden]')];
    gizli.slice(0, 4).forEach((li) => {
      li.hidden = false;
      li.setAttribute('data-kz-gorundu', '');
    });
    if (gizli[0]) {
      gizli[0].setAttribute('tabindex', '-1');
      gizli[0].focus();
    }
    if (!kap.querySelector('[data-kz-yorum-gizli][hidden]')) buton.remove();
  });

  } catch(e) { console.error(e); }
})();
})();
